import get from 'lodash/get'

import { CodeText } from '../redux/reducers/codetable/model'

export const notNullNorUndefined = (value: any) => {
  if (value !== null && value !== undefined) {
    return true
  }
  return false
}

export const getIntegerOrZero = (value: any): number => {
  if (notNullNorUndefined(value)) {
    let ret: number = 0
    try {
      ret = parseInt(value.toString().replace(/\s/, ''), 10)
    } catch (e) {
      ret = 0
    }

    return ret
  }

  return 0
}

export const getIntegerOrNull = (value: any): number | null => {
  if (notNullNorUndefined(value)) {
    let ret: number | null = null
    try {
      ret = parseInt(value.toString().replace(/\s/, ''), 10)
    } catch (e) {
      ret = null
    }

    return ret
  }

  return null
}

export const findClosestInArray = (val: any, arr: number[]) => {
  let value: any = getIntegerOrNull(val)

  if (notNullNorUndefined(value) && !Number.isNaN(value)) {
    const indexArr = arr.map((num: number) => Math.abs(num - value))
    // TODO Fix Eslint
    // eslint-disable-next-line prefer-spread
    const min = Math.min.apply(Math, indexArr)
    value = arr[indexArr.indexOf(min)]
  } else {
    value = arr[0]
  }

  return value
}

export const compareValidValuesWithoutSpaces = (valueA: any, valueB: any) => {
  if (valueA === valueB) {
    return true
  } else if (notNullNorUndefined(valueA) && notNullNorUndefined(valueB)) {
    const valA: string = valueA.toString().replace(/\s/g, '')
    const valB: string = valueB.toString().replace(/\s/g, '')

    if (valA === valB) {
      return true
    }
    return false
  }

  return false
}

export const translateCodetable = (codetable?: CodeText[], code?: any) => {
  if (codetable && code) {
    const codeText: undefined | CodeText = codetable.find(
      (item: CodeText) => item.code === code.toString()
    )
    if (codeText) {
      return codeText.text
    }
  }

  return code
}

export const translateOccupation = (
  occupationsByEmploymentTypeCodetable: any,
  employmentTypeCode: any,
  occupationCode: any
) => {
  if (occupationsByEmploymentTypeCodetable && employmentTypeCode && occupationCode) {
    const occupations: CodeText[] = get(occupationsByEmploymentTypeCodetable, employmentTypeCode)
    if (occupations) {
      const occupation: undefined | CodeText = occupations.find(
        (item: CodeText) => item.code === occupationCode.toString()
      )
      if (occupation) {
        return occupation.text
      }
    }
  }
  return occupationCode
}

export const copyToClipboard = (str: string | number) => {
  const el = document.createElement('textarea')
  el.value = `${str}`
  el.setAttribute('readonly', '')
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}
